import React, { useState, useEffect } from "react";
import { Button } from "@progress/kendo-react-buttons";
import {
  ListView,
  ListViewHeader,
  ListViewFooter,
  ListViewItemProps,
} from "@progress/kendo-react-listview";

const ListViewComponent = (lvcprops: any) => {
  const Header = () => {
    return (
      <ListViewHeader
        style={{ fontSize: 17, backgroundColor: "#ccc" }}
        className="pl-3 pb-2 pt-2"
      >
        {lvcprops.header}
      </ListViewHeader>
    );
  };

  const ItemRender = (props: ListViewItemProps) => {
    let item = props.dataItem;
    return (
      <div style={{ margin: 20 }}>
        <div
          onClick={() => {
            lvcprops.handleSelect({ name: item.name, source: item.source });
          }}
        >
          <h2 style={{ fontSize: 14, color: "#454545", marginBottom: 0 }}>
            <li style={{ cursor: "pointer", width: "450px" }}>{item.name}</li>
          </h2>
        </div>
      </div>
    );
  };
  return (
    <ListView
      data={lvcprops.data}
      item={ItemRender}
      style={{ width: "100%" }}
      header={Header}
    />
  );
};

const VideoDemos = () => {
  const [selected, updateSelected] = useState(null);
  const handleSelect = (e: any) => {
    updateSelected(e);
  };

  if (selected != null) {
    return (
      <div>
        <video width="420" height="280" controls>
          <source src={selected.source} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div>
          <Button onClick={() => handleSelect(null)}> Close</Button>
          <p>Use the video player controls to show fullscreen</p>
        </div>
      </div>
    );
  }
  const SidebarData = [
    { name: "Filters", source: "../../assets/video/deviceFilters.mp4" },
    { name: "Alarm Filters", source: "../../assets/video/alarmFilters.mp4" },
    {
      name: "Published Filters",
      source: "../../assets/video/publishedFilters.mp4",
    },
    {
      name: "Dashboard Options",
      source: "../../assets/video/dashboardButtons.mp4",
    },
  ];
  const ChartsData = [
    {
      name: "Alarm Column Charts",
      source: "../../assets/video/alarmColumnChart.mp4",
    },
  ];
  const RootCauseData = [
    { name: "Root Cause Analysis", source: "../../assets/video/rootcause.mp4" },
  ];
  const GeneralData = [
    { name: "Grid features", source: "../../assets/video/datagrid.mp4" },
    //{
    //  name: "Custom Dashboard",
    //  source: "../../assets/video/customDashboard.mp4",
    //},
    { name: "Data Export", source: "../../assets/video/dataExportAll.mp4" },
  ];

  return (
    <div>
      <p>Click on a topic item to open video demo</p>

      <ListViewComponent
        data={GeneralData}
        header={"General features"}
        handleSelect={handleSelect}
      />
      {/*<ListViewComponent*/}
      {/*  data={SidebarData}*/}
      {/*  header={"Sidebar Items"}*/}
      {/*  handleSelect={handleSelect}*/}
      {/*/>*/}
      {/*<ListViewComponent*/}
      {/*  data={ChartsData}*/}
      {/*  header={"Charts"}*/}
      {/*  handleSelect={handleSelect}*/}
      {/*/>*/}
      {/*<ListViewComponent*/}
      {/*  data={RootCauseData}*/}
      {/*  header={"Root Cause Widgets"}*/}
      {/*  handleSelect={handleSelect}*/}
      {/*/>*/}
    </div>
  );
};

export default VideoDemos;
